import React, { Component,useEffect,useState } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../config.js'
import DataTable,{defaultThemes} from 'react-data-table-component';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import HTMLParserComponent from "../HTMLParserComponent.js";
import Pagination from '../Pagination/Paginations.js';
import EntriesSelector from '../Pagination/EntriesSelector';
import useSortData from "../Pagination/SortData";

import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import '../preloading.css';




import {
    statisticsAction,
    statisticsCloseAction
} from '../../actions/settingsAction.js';
import { Link } from 'react-router-dom/cjs/react-router-dom.min.js';
const SalaryApproval = (props) => {
    const sparkline1 = React.createRef();
    const sparkline2 = React.createRef();
    const sparkline3 = React.createRef();
    const sparkline4 = React.createRef();


    const handleStatistics = (e) => {
        statisticsAction(e)
    }
    const closeStatistics = (e) => {
        statisticsCloseAction(e)
    }

    const { fixNavbar, statisticsOpen, statisticsClose } = props;

    // function getDate() {
    // 	const today = new Date();
    // 	const month = today.getMonth() + 1;
    // 	const year = today.getFullYear();
    // 	const date = today.getDate();
    // 	return `${year}-${month}-${date}`;
    //   }

    const today = new Date().toISOString().split("T")[0];


    const [user, setUser] = useState({
        employee_id: "0",
        department_id:"0",
    })


      const [department, setDepartmentValue] = useState("0");
      const [employeeDropdownOptions,setEmployeeDropdownOptions]=useState([]);
      const [employeedet,setEmployeeValue] = useState("0");
     
     
      const handleFirstDropdownChange = (event) => {
         const value = event.target.value;

        //  alert(value);
         setDepartmentValue(value);
     
         // Trigger API call based on the selected value
         fetchSecondDropdownOptions(value);
       };
     
     
          // Fetch options for the second dropdown
         const fetchSecondDropdownOptions = async (selectedValue) => {
     
          try {
          
        const response = await fetch(
              API_BASE_URL + '/showdeptbase_all_emp/'+selectedValue, {
                headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
            }
            ); // Replace with your API URL
       
            const data = await response.json();
            console.log(data);
     
            setEmployeeDropdownOptions(data); // Assuming the API returns an array of options
          } catch (error) {
            console.error("Error fetching second dropdown options:", error);
          }
        };
     
     
          // Handle second dropdown change
          const handleSecondDropdownChange = (event) => {
            // setSecondDropdownValue(event.target.value);
            setEmployeeValue(event.target.value);
          };
    

    
    const history = useHistory();
    const [data, setData]= useState([]);
    const [dataval, setdataval]= useState([]);
    const [attnlist, setattnlist]= useState([]);
    const [isVisible, setIsVisible] = useState(false);
    const [urlres, setUrlRes] = useState(false);
    const [style1,setStyle1]=useState(false);
    const [records, setRecords] = useState([]);
    const [loading, setLoading] = useState(false);

    const { sortConfig, sortData, handleSort } = useSortData();


    const handelInput = (event) => {
        event.preventDefault();
        const { name, value } = event.target;
        console.log(name, value)
        setUser({ ...user, [name]: value });

    
    }

    const [shiftcode,setShiftCodeValue]= useState("");
    const [officeshift,setOfficeShift]= useState([]);

    const handleShift = (event) => {
    const value = event.target.value;
    setShiftCodeValue(value);

    
  };

        const [checkedItems, setCheckedItems] = useState({});
        const [salaryDetails, setSalaryDetails] = useState(null);
        const [loadingDetails, setLoadingDetails] = useState(false);
        const [searchTerm, setSearchTerm] = useState("");
        const [currentPage, setCurrentPage] = useState(1);
        const [entriesPerPage,setEntriesPerPage]=useState(10);
        let filteredItems = records.filter((item) =>
            `${item.employee_id.toLowerCase()}${item.employee_name.toLowerCase()}`.includes(searchTerm.toLowerCase())
         
        );
        const totalPages = Math.ceil(filteredItems.length / entriesPerPage);
    const indexOfLast = currentPage * entriesPerPage;
    const indexOfFirst = indexOfLast - entriesPerPage;
    // const filteredData = filteredItems.slice(indexOfFirst, indexOfLast);

     const sortedItems = sortData(filteredItems);
		const filteredData = sortedItems.slice(indexOfFirst, indexOfLast);
      
        useEffect(() => {
          setCurrentPage(1);
        }, [searchTerm]);
      
        const paginate = (pageNumber) => setCurrentPage(pageNumber);
    
      const handleSearch = (event) => {
        //console.log(event.target.value);
         setSearchTerm(event.target.value);
      };
    
    //   const handleRowsPerPageChange = (e) => {
    // 	setItemsPerPage(Number(e.target.value));
    // 	setCurrentPage(1); // Reset to first page
    //   };





      const handleDepartment = async () => {
      
        axios.get(API_BASE_URL +'/showdepartment/', { headers : {
               'Content-Type': 'application/json',
               //'Authorization': 'Bearer 154|DKlDECT0m8FjNaqkz80nCzrt5ziZ8kW2XsaIzEkj260b0b39'
       }})
        .then(res1 => setdataval(res1.data))
        .catch(err => console.log(err))
       };
  
  
       useEffect(() => {
        handleDepartment();
      }, []);



      const handleShiftCode = async () => {

    axios.get(API_BASE_URL + '/read_shift_info', {
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    })
//    .then(res1 => console.log(res1.data))
    .then(res1 => setOfficeShift(res1.data))
    .catch(err => console.log(err))
   };

    useEffect(() => {
    handleShiftCode();
     }, []);



     const handleViewSalary = async (empId) => {
  setLoadingDetails(true);
  setSalaryDetails(null);
  try {
    const res = await axios.get(`${API_BASE_URL}/get_emp_salary_details/${empId}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    });

    if (res.data.status === 200) {
      setSalaryDetails(res.data);
      window.$("#salaryDetailsModal").modal("show");
    } else {
      toast.warn(res.data.message || "No data found.");
    }
  } catch (err) {
    console.error(err);
    toast.error("Failed to fetch employee details.");
  } finally {
    setLoadingDetails(false);
  }
};



const handleApproveSelected = async () => {
  // ✅ Extract IDs properly (no NaN issue)
  const selected = Object.entries(checkedItems)
    .filter(([_, v]) => v === true)
    .map(([k]) => Number(k)); // safer than parseInt

  console.log("Selected IDs:", selected);

 if (selected.length === 0) {
  toast.warn("Please select at least one record!", {
    position: "bottom-right",
    style: {
      backgroundColor: "#dc3545", // 🔴 red background (Bootstrap danger)
      color: "#fff",
    },
  });
  return;
}

  // 🧠 Show which salary IDs are selected
  // alert(`Selected Salary IDs: ${selected.join(", ")}`);

  if (!window.confirm(`Approve ${selected.length} salary records?`)) return;

  try {
    const res = await axios.post(
      `${API_BASE_URL}/approve_salary`,
      { salary_ids: selected },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      }
    );

    if (res.data.status === 200) {
  toast.success("Selected salaries approved successfully!", {
    position: "bottom-right",
    style: {
      backgroundColor: "#28a745", // ✅ Green for success
      color: "#fff",
    },
  });
  fetchRecords(); // reload table
} else {
  toast.error(res.data.message || "Error approving salaries", {
    position: "bottom-right",
    style: {
      backgroundColor: "#dc3545", // ✅ Red for error
      color: "#fff",
    },
  });
}
  } catch (err) {
     console.error(err);
  toast.error("Server error during approval", {
    position: "bottom-right",
    style: {
      backgroundColor: "#dc3545",
      color: "#fff",
    },
  });
  }
};




const handleRejectSelected = async () => {
  // ✅ Extract IDs properly (no NaN issue)
  const selected = Object.entries(checkedItems)
    .filter(([_, v]) => v === true)
    .map(([k]) => Number(k)); // safer than parseInt

  console.log("Selected IDs:", selected);
  //  alert(`Selected Salary IDs: ${selected.join(", ")}`);

  if (selected.length === 0) {
  toast.warn("Please select at least one record!", {
    position: "bottom-right",
    style: {
      backgroundColor: "#dc3545", // 🔴 red background (Bootstrap danger)
      color: "#fff",
    },
  });
  return;
}
  // 🧠 Show which salary IDs are selected
 

  if (!window.confirm(`Approve ${selected.length} salary records?`)) return;

  try {
    const res = await axios.post(
      `${API_BASE_URL}/reject_salary`,
      { salary_ids: selected },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      }
    );

     if (res.data.status === 200) {
      toast.success("Selected salaries rejected successfully!", {
    position: "bottom-right",
    style: {
      backgroundColor: "#28a745", // ✅ Green for success
      color: "#fff",
    },
     });
      fetchRecords();
    } else {
      toast.error(res.data.message || "Error rejecting salaries");
    }
  } catch (err) {
    console.error(err);
    toast.error("Server error during rejection");
  }
};




const initChecked = (list) =>
  list.reduce((acc, item) => {
    if (item?.salary_id != null) acc[item.salary_id] = true; // default checked
    return acc;
  }, {})


const fetchRecords = async () => {
  try {
    const response = await axios.post(
      API_BASE_URL + '/salaryapproval',
      {},
      { headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` } }
    );

    const salaryList = response.data.salaryapproval || [];
    setRecords(salaryList);

    // ✅ all checked by default
    const defaultChecked = salaryList.reduce((acc, item) => {
      acc[item.salary_id] = true;
      return acc;
    }, {});
    setCheckedItems(defaultChecked);

  } catch (err) {
    console.log(err);
  }
};




useEffect(() => { fetchRecords(); }, []);





const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // alert(user.start_date);
    // alert(user.department);
    try {
      const response = await axios.post(API_BASE_URL +'/managesalary',
        { department_id: department, employee_id: employeedet }, 
        {
            headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
        }

);
console.log(response.data.managesalary);
      setRecords(response.data.managesalary); // Assuming the API response contains the records in `response.data`
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  useEffect(()=> {
    axios.post(API_BASE_URL +'/salaryapproval',{ }, {
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    })

    //  .then(response =>console.log(response.data.salaryapproval))
     .then(response => setRecords(response.data.salaryapproval))
    .catch(err => console.log(err));
},[])




   const columns = [
	{ label: "Emp Id", key: "employee_id", sortable: true },
	{ label: "Employee Name", key: "employee_name", sortable: true },
	{ label: "Department", key: "department_name", sortable: true },
  { label: "Gross Salary", key: "gross_salary", sortable: true },
  { label: "Salary Id", key: "salary_id", sortable: true }

];


    return (
        <>
            <div>
                <div>
                    <div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
                        <div className="container-fluid">

                        <ToastContainer/>
                            

                        </div>


                        
                    </div>


                    








                    <div className="section-body">
                        <div className="container-fluid">
                            <div className="tab-content">
                                <div className="tab-pane fade show active" id="Employee-list" role="tabpanel">
                                    <div className="card">

                                        <div className="card-header">
                                            <h3 className="card-title" style={{color:'#e96827'}}>Salary Approval</h3>
                                            <div className="card-options">
                                                <form>
                                                    <div className="input-group">
                                                    <EntriesSelector 
                                                        setEntriesPerPage={setEntriesPerPage}
                                                        setCurrentPage={setCurrentPage}
                                                        /> 
                                                    
                                                         <input
                                                            type="text"
                                                            className="form-control form-control-sm"
                                                            placeholder="Search"
                                                            value={searchTerm}
                                                            onChange={e => {
                                                            setSearchTerm(e.target.value);
                                                            setCurrentPage(1);
                                                            }} style={{ padding: '8px', width: '200px', borderRadius: '4px', border: '1px solid #ccc' }} 
                                                        />
                                                    </div>
                                                </form>
                                            </div>
                                        </div>


{loading && (
                                            <div className="card-body">
                                            <div class="d-flex justify-content-center">
       <div class="spinner"></div>
       </div>
       </div>
      )}

{!loading && (
                                        <div className="card-body">
                                        
                                            <div className="table-responsive">
        

    
      
            <table className="table table-hover table-striped table-vcenter text-nowrap mb-0">
                                                    <thead>
                                                        <tr>
                                                            <th style={{ textAlign: "center" }}>
  {/* <input
    type="checkbox"
    checked={
      records.length > 0 &&
      records.every((r) => checkedItems?.[r.salary_id])
    }
    onChange={(e) => {
      const newChecked = {};
      const isChecked = e.target.checked;
      if (isChecked) {
        records.forEach((r) => (newChecked[r.salary_id] = true));
      }
      setCheckedItems(newChecked);
    }}
  /> */}
</th>



                                                             {columns.map((col) => (
																<th
																	key={col.key}
																	onClick={col.sortable ? () => handleSort(col.key) : null}
																	style={{ cursor: col.sortable ? "pointer" : "default" }}
																>
																	{col.label}
																	{col.sortable && (
																sortConfig.key === col.key
																	? (sortConfig.direction === "asc" ? " ▲" : " ▼")
																	: " ⇅"   // <-- DEFAULT SORT ICON
																)}
																	</th>
																))}          
                                                            <th>Action</th>
                                                            
                                                            
                                                            
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {/* {console.log(records)} */}
                                                    {records.length > 0 ? (
                                                            filteredData.map((record) => {

                                                            
                                                            return(
                                                            <tr key={record.employee_id}>
                                                              <td style={{ textAlign: "center" }}>
  {/* <input
  type="checkbox"
  checked={checkedItems[record.salary_id] || false}
  onChange={(e) =>
    setCheckedItems((prev) => ({
      ...prev,
      [record.salary_id]: e.target.checked,
    }))
  }
/> */}


<input
  type="checkbox"
  value={record.salary_id}
  checked={checkedItems[record.salary_id] || false}
  onChange={(e) => {
    const isChecked = e.target.checked; // ✅ store first (avoid null reference)
    const id = record.salary_id;

    setCheckedItems((prev) => ({
      ...prev,
      [id]: isChecked,
    }));
  }}
/>
</td>








                                                                <td>{record.employee_id}</td>
                                                                <td>{record.employee_name}</td>
                                                                <td>{record.department_name}</td>
                                                                <td>{record.gross_salary}</td>
                                                                <td>{record.salary_id}</td>
                                                                <td><button
																		type="button" onClick={() =>{ handleViewSalary(record.employee_id)}}
																		className="btn btn-primary"
																		data-toggle="modal"
																		data-target="#salaryDetailsModal"
																		>
																	view
																	</button></td>
                                                                
                                                            </tr>
                                                            )
})
                                                        ) : (
                                                            <tr>
                                                            <td colSpan="12" style={{ color: 'red', textAlign: 'center',fontWeight: "bold" }}>No records found</td>
                                                            </tr>
                                                        )}

                                            
                                                    </tbody>
                                                </table>
                                            </div>
                                        
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
            />


            <div className="d-flex gap-2 mt-3">
															<button className="tag tag-warning" onClick={handleApproveSelected}>
																<i className="fa fa-check-circle" style={{fontSize:'10px',fontWeight:'900',marginTop:'6px'}} />Approval
															</button>&nbsp;&nbsp;
															<button className="tag tag-danger" style={{fontSize:'10px',fontWeight:'900'}} onClick={handleRejectSelected}>
																 Reject
															</button>
															</div>			
                                

                                        </div> 
)
}
                                    </div>
                                </div>
    
                            
                            </div>
                        </div>
                    </div>

                </div>
            </div> 

                                        
            
<div className="modal fade" id="salaryDetailsModal" tabIndex="-1" role="dialog" aria-hidden="true">
  <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div className="modal-content">
      <div className="modal-header bg-light">
        <h5 className="modal-title">Salary Details</h5>
        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
          <span>&times;</span>
        </button>
      </div>

      <div className="modal-body">
        {loadingDetails ? (
          <div className="text-center my-3">
            <i className="fa fa-spinner fa-spin fa-2x"></i>
            <p>Loading...</p>
          </div>
        ) : salaryDetails ? (
          <>
            {/* Employee Info */}
            <div className="row mb-3">
              <div className="col-sm-3 text-center">
                <img
                  src={`${API_BASE_URL}/uploads/profile/${salaryDetails.emp_details[0].profile_picture}`}
                  alt="Profile"
                  style={{ width: "100px", height: "100px", borderRadius: "50%", border: "3px solid #ccc" }}
                />
              </div>
              <div className="col-sm-9">
                <h6>Employee Name: {salaryDetails.emp_details[0].first_name} {salaryDetails.emp_details[0].last_name} ({salaryDetails.emp_details[0].employee_id})</h6>
                <h6>Department: {salaryDetails.emp_details[0].department_name}</h6>
                <h6>Designation: {salaryDetails.emp_details[0].designation_name}</h6>
              </div>
            </div>

            {/* Salary Table */}
            <table className="table table-bordered table-sm">
              <thead className="thead-light">
                <tr>
                  <th>Basic Salary</th>
                  <th>Gross Salary</th>
                  <th>CTC</th>
                  <th>Last Update</th>
                  <th>Status</th>
                  <th>Approval Date</th>
                </tr>
              </thead>
              <tbody>
                {salaryDetails.salary_info.map((row, idx) => (
                  <tr key={idx}>
                    <td>{row.basic_sal}</td>
                    <td>{row.gross_salary}</td>
                    <td>{row.ctc}</td>
                    <td>{row.last_update}</td>
                    <td>
                      <span className={`badge ${row.salary_approval_flag === "APPROVED" ? "bg-success" : "bg-danger"}`}>
                        {row.salary_approval_flag}
                      </span>
                    </td>
                    <td>{row.salary_approval_date || "--"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        ) : (
          <p className="text-muted text-center">No data available</p>
        )}
      </div>
    </div>
  </div>
</div>


            
            


            

        </>
    );
}

const mapStateToProps = (state) => ({
    fixNavbar: state.settings.isFixNavbar,
    statisticsOpen: state.settings.isStatistics,
    statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
    statisticsAction: (e) => dispatch(statisticsAction(e)),
    statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(SalaryApproval);